/* New Athlete (test) — behaviour for sections/new-athlete.liquid.
   Reads its data (stack items to add, discount code) from the JSON script
   tag #na-data. Uses window.npCart (assets/np-chrome.js) for the actual
   cart/add.js call; falls back to a rejected promise if it is missing so the
   button still reports a friendly error instead of throwing. */
(function () {
  var $ = function (id) { return document.getElementById(id); };

  var dataEl = $("na-data");
  var DATA = {};
  if (dataEl) {
    try { DATA = JSON.parse(dataEl.textContent) || {}; } catch (e) { DATA = {}; }
  }
  var ITEMS = DATA.items || [];
  var CODE = DATA.code || "";

  var copy = $("na-copy");
  if (copy) {
    copy.addEventListener("click", function () {
      var code = copy.getAttribute("data-code");
      var label = $("na-copy-label");
      if (navigator.clipboard && code) { navigator.clipboard.writeText(code).catch(function () {}); }
      if (label) {
        label.textContent = "COPIED";
        setTimeout(function () { label.textContent = code; }, 1800);
      }
    });
  }

  var add = $("na-addstack");
  function showErr(m) {
    var e = $("na-err");
    if (!e) return;
    e.textContent = m || "";
    e.style.display = m ? "block" : "none";
  }

  if (add) {
    add.addEventListener("click", function () {
      if (!ITEMS.length) { showErr("Nothing in this stack is available right now."); return; }
      showErr("");
      var hasCode = CODE && /^[a-zA-Z0-9_-]{1,50}$/.test(CODE);
      var prevLabel = add.textContent;
      add.textContent = "Adding…";
      var request = window.npCart
        ? window.npCart.add(ITEMS, { button: add, open: !hasCode })
        : Promise.reject(new Error("Please try again"));
      request
        .then(function () {
          if (hasCode) {
            window.location.href = "/discount/" + encodeURIComponent(CODE) + "?redirect=" + encodeURIComponent("/cart");
          } else {
            add.textContent = prevLabel;
          }
        })
        .catch(function (err) {
          add.textContent = prevLabel;
          showErr((err && err.message) || "Unable to add the stack. Please try again.");
        });
    });
  }
})();
